import { ApiService } from "../api";
import { Tag } from "./Tag";

export class TagService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findAll(): Promise<Tag[]> {
		const response = await this.apiService.get("/api/v1/tags");
		const tags = await response.json();

		return Tag.fromJsonArray(tags);
	}

	public async create(name: string): Promise<Tag> {
		const response = await this.apiService.post("/api/v1/tags", { name });
		const tag = await response.json();

		return Tag.fromJson(tag);
	}

	public async save(tag: Tag): Promise<Tag> {
		const response = await this.apiService.post(`/api/v1/tag/${tag.id}`, {
			name: tag.name,
		});
		const updated = await response.json();

		return Tag.fromJson(updated);
	}

	public async delete(tag: Tag): Promise<void> {
		await this.apiService.delete(`/api/v1/tag/${tag.id}`);
	}
}
